import FullScreenMap from 'components/FullScreenMap';
import Massive_Unionized_MultiPolygons from 'data/Massive_Unionized_MultiPolygons.json';
import Cookies from 'js-cookie';
import L from 'leaflet';
import { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker } from 'react-leaflet';
import { useGetAllActiveAlertsQuery } from 'services/alerts/alerts.api';
import { flattenPolygon } from 'utils/geometryUtils';
import CustomAlert from './CustomAlert';
import MapUpdater from './MapUpdater';
import ZonePolygonAlerts from './ZonePolygonAlerts';
export default function MapPanel({
  fullScreen,
  selectedZone,
  setSelectedZone,
  selectedAlert,
  setSelectedAlert,
  widgetRefresh,
  preview,
  includePopup = false,
  sidebarOpen,
}) {
  const { data: allActiveAlerts = [] } = useGetAllActiveAlertsQuery();
  const [popupOpen, setPopupOpen] = useState(false);
  const [mapCenter, setMapCenter] = useState([51.505, -0.09]);
  const [loading, setLoading] = useState(true);

  const [arrayOfZoneAlerts, setZoneAlerts] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState([0, 0]);

  //   "Check:",
  //   includePopup &&
  //     selectedPosition &&
  //     (selectedZone !== null || selectedAlert !== null)
  // );

  useEffect(() => {
    const arrayOfZoneCodes = [];

    if (allActiveAlerts) {
      allActiveAlerts.forEach((alert) => {
        if (alert.zoneCodes) {
          const arrayOfZones = alert.zoneCodes;

          arrayOfZones.forEach((zoneCode) => {
            // check if county code is already in array
            let foundObj = arrayOfZoneCodes.find((obj) => obj.zoneCode == zoneCode);

            //if county code is in array, add alert to it
            if (foundObj) {
              if (!foundObj.alerts.some((existingAlert) => existingAlert.id === alert.id)) {
                foundObj.alerts.push(alert);
              }
            } else {
              //add either zone or county to array with new element
              arrayOfZoneCodes.push({
                zoneCode: zoneCode,
                alerts: [alert],
              });
            }
          });
        }
      });
    }
    setZoneAlerts(arrayOfZoneCodes);
  }, [allActiveAlerts]);

  useEffect(() => {
    setMapCenter([Cookies.get('latitude'), Cookies.get('longitude')]);
    setLoading(false);
  }, [widgetRefresh]);

  useEffect(() => {
    setPopupOpen(true);
  }, [selectedZone, selectedAlert]);

  const createCustomIcon = () => {
    const alert = selectedZone?.alerts[0] || selectedAlert;

    if (alert)
      return L.divIcon({
        html: ReactDOMServer.renderToString(
          <div
            className="d-flex flex-column justify-content-center p-2 bg-white text-black position-relative z-2"
            style={{
              minHeight: '100px',
              width: 300,
            }}
          >
            <div className="fw-bold">{alert?.type}</div>
            <div className="d-flex flex-row">
              <div className="m-1">Message:</div>
              {alert?.description}
            </div>
            <div className="d-flex flex-row">
              <div className="m-1 fw-bold">Start Time:</div>
              {alert?.startTime}
            </div>
            <div className="d-flex flex-row">
              <div className="m-1 fw-bold">Expire Time:</div>
              {alert?.endTime}
            </div>
            <div className="d-flex flex-row">
              <div className="m-1 fw-bold">Issuing Office:</div>
              {alert?.sender}
            </div>
            {selectedZone && (
              <div className="d-flex flex-row">
                <div className="m-1 fw-bold">Location:</div>
                {selectedZone.zoneCode}
              </div>
            )}
          </div>,
        ),
      });
  };

  const emptyCustomIcon = () => {
    return L.icon({
      iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
  };

  if (fullScreen)
    return (
      <div className="h-100 w-100 d-flex flex-column position-relative z-0">
        {!loading && (
          <FullScreenMap key={'fullScreenMap'} mapCenter={mapCenter} zoom={9}>
            {arrayOfZoneAlerts.map((zoneCodeOBJ, index) => {
              return (
                <div key={index}>
                  <ZonePolygonAlerts
                    zoneCodeOBJ={zoneCodeOBJ}
                    setSelectedZone={setSelectedZone}
                    setSelectedAlert={setSelectedAlert}
                    setMapCenter={setMapCenter}
                    setSelectedPosition={setSelectedPosition}
                  />
                </div>
              );
            })}

            {allActiveAlerts &&
              allActiveAlerts.length > 0 &&
              allActiveAlerts.map((alert, index) => {
                if (alert.provider === 'Fusion') {
                  return (
                    <div key={index}>
                      <CustomAlert
                        alert={alert}
                        setSelectedAlert={setSelectedAlert}
                        setSelectedZone={setSelectedZone}
                        setMapCenter={setMapCenter}
                        setSelectedPosition={setSelectedPosition}
                      />
                    </div>
                  );
                }
              })}

            {selectedAlert && selectedAlert.polygon && !selectedZone && (
              <MapUpdater
                positions={JSON.parse(selectedAlert.polygon).map(([lng, lat]) => [lng, lat])}
              />
            )}

            {selectedZone && (
              <MapUpdater
                positions={(() => {
                  const response = flattenPolygon(
                    Massive_Unionized_MultiPolygons[selectedZone?.zoneCode][0],
                  );
                  const swappedPolygon = response.map((coord) => [coord[1], coord[0]]);

                  return swappedPolygon;
                })()}
              />
            )}
          </FullScreenMap>
        )}
      </div>
    );
  else
    return (
      <div className="h-100 flex-grow-full">
        {!loading && (
          <div className="h-100 flex-column">
            <div className="h-100 d-flex">
              <FullScreenMap
                sidebarOpen={sidebarOpen}
                mapCenter={mapCenter}
                zoom={9}
                preview={preview}
              >
                {arrayOfZoneAlerts.map((zoneCodeOBJ, index) => {
                  return (
                    <div key={index}>
                      <ZonePolygonAlerts
                        zoneCodeOBJ={zoneCodeOBJ}
                        setSelectedZone={setSelectedZone}
                        setSelectedAlert={setSelectedAlert}
                        setMapCenter={setMapCenter}
                        setSelectedPosition={setSelectedPosition}
                      />
                    </div>
                  );
                })}

                {allActiveAlerts &&
                  allActiveAlerts.length > 0 &&
                  allActiveAlerts.map((alert, index) => {
                    if (alert.provider === 'Fusion') {
                      return (
                        <div key={index}>
                          <CustomAlert
                            alert={alert}
                            setSelectedAlert={setSelectedAlert}
                            setSelectedZone={setSelectedZone}
                            setMapCenter={setMapCenter}
                            setSelectedPosition={setSelectedPosition}
                          />
                        </div>
                      );
                    }
                  })}

                {selectedAlert && selectedAlert.polygon && !selectedZone && (
                  <MapUpdater
                    positions={JSON.parse(selectedAlert.polygon).map(([lng, lat]) => [lng, lat])}
                  />
                )}

                {selectedZone && (
                  <MapUpdater
                    positions={(() => {
                      const response = flattenPolygon(
                        Massive_Unionized_MultiPolygons[selectedZone?.zoneCode][0],
                      );
                      const swappedPolygon = response.map((coord) => [coord[1], coord[0]]);

                      return swappedPolygon;
                    })()}
                  />
                )}

                {includePopup &&
                  selectedPosition &&
                  (selectedZone !== null || selectedAlert !== null) && (
                    <div className="z-3">
                      {popupOpen && (
                        <Marker
                          position={[selectedPosition[0], selectedPosition[1]]}
                          icon={popupOpen ? createCustomIcon() : emptyCustomIcon()}
                          eventHandlers={{
                            click: () => {
                              setPopupOpen(false);
                            },
                          }}
                        />
                      )}
                      {!popupOpen && (
                        <Marker
                          position={[selectedPosition[0], selectedPosition[1]]}
                          eventHandlers={{
                            click: () => {
                              setPopupOpen(true);
                            },
                          }}
                        />
                      )}
                    </div>
                  )}
              </FullScreenMap>
            </div>
          </div>
        )}
      </div>
    );
}
